<template>
  <div>
    <div class="flex-1 w-full px-4 py-2 m-2 text-center">
      <h1>{{ getText('difficulty_title') }}</h1>
      <div class="text">{{ getText('difficulty_text') }}</div>
      <div class="flex flex-row justify-center ml-auto mr-auto mt-5">
        <div
          class="column"
          :style="{ filter: currentlyPlaying && currentlyPlaying != 'easy' ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="box">
            <div class="title">{{ this.getText('difficulty_easy_title')}}</div>
            <div class="subtitle">{{ this.getText('difficulty_easy')}}</div>
            <div class="difficulty">
              <img src="images/difficulty.svg" />
              <img src="images/difficulty.svg" style="filter: opacity(.3)" />
              <img src="images/difficulty.svg" style="filter: opacity(.3)" />
            </div>
          </div>
          <button
            class="py-3 px-10 rounded-full w-full border-2 border-white text-white border-solid"
            @click="play('easy')"
            :disabled="currentlyPlaying != null"
            :class="{ 'opacity-50 cursor-not-allowed': currentlyPlaying != null }"
          >
            <span v-if="!currentlyPlaying || currentlyPlaying != 'easy'">{{ this.getText('button_play')}}</span>
            <jumper v-if="currentlyPlaying == 'easy'"></jumper>
          </button>
          <button
            class="bg-white text-black py-3 px-10 rounded-full w-full shadow-md"
            @click="nextStep('easy')"
          >{{ this.getText('button_select')}}</button>
        </div>
        <div
          class="column"
          :style="{ filter: currentlyPlaying && currentlyPlaying != 'medium' ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="box">
            <div class="title">{{ this.getText('difficulty_medium_title')}}</div>
            <div class="subtitle">{{ this.getText('difficulty_medium')}}</div>
            <div class="difficulty">
              <img src="images/difficulty.svg" />
              <img src="images/difficulty.svg" />
              <img src="images/difficulty.svg" style="filter: opacity(.3)" />
            </div>
          </div>
          <button
            class="py-3 px-10 rounded-full w-full border-2 border-white text-white border-solid"
            @click="play('medium')"
            :disabled="currentlyPlaying != null"
            :class="{ 'opacity-50 cursor-not-allowed': currentlyPlaying != null }"
          >
            <span v-if="!currentlyPlaying || currentlyPlaying != 'medium'">{{ this.getText('button_play')}}</span>
            <jumper v-if="currentlyPlaying == 'medium'"></jumper>
          </button>
          <button
            class="bg-white text-black font-bold py-3 px-10 rounded-full w-full shadow-md"
            @click="nextStep('medium')"
          >{{ this.getText('button_select')}}</button>
        </div>
        <div
          class="column"
          :style="{ filter: currentlyPlaying && currentlyPlaying != 'hard' ? 'opacity(0.5)' : 'opacity(1)' }"
        >
          <div class="box">
            <div class="title">{{ this.getText('difficulty_hard_title')}}</div>
            <div class="subtitle">{{ this.getText('difficulty_hard')}}</div>
            <div class="difficulty">
              <img src="images/difficulty.svg" />
              <img src="images/difficulty.svg" />
              <img src="images/difficulty.svg" />
            </div>
          </div>
          <button
            class="py-3 px-10 rounded-full w-full border-2 border-white text-white border-solid"
            @click="play('hard')"
            :disabled="currentlyPlaying != null"
            :class="{ 'opacity-50 cursor-not-allowed': currentlyPlaying != null }"
          >
            <span v-if="!currentlyPlaying || currentlyPlaying != 'hard'">{{ this.getText('button_play')}}</span>
            <jumper v-if="currentlyPlaying == 'hard'"></jumper>
          </button>
          <button
            class="bg-white text-black font-bold py-3 px-10 rounded-full w-full shadow-md"
            @click="nextStep('hard')"
          >{{ this.getText('button_select')}}</button>
        </div>
      </div>
    </div>

    <audio id="difficultyAudio">
      <source src="sounds/easy_f.mp3" type="audio/mp3" />
    </audio>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
  margin-top: 70px;
}

button {
  margin-top: 15px;
}

.text {
  font-family: FoundryWilsonNormal;
  font-size: 25px;
  width: 910px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  letter-spacing: 1px;
}

.column {
  width: 430px;
  margin: 20px;
}

.column button:first-of-type {
  color: white !important;
}

.box {
  background-color: #e4e1db;
  padding: 60px;
  border-radius: 30px;
  color: #544b45;
  width: 430px;
}

.box .title {
  text-transform: uppercase;
  font-size: 36px;
}

.box .subtitle {
  font-family: FoundryWilsonItalic;
  font-size: 31px;
}

.box .difficulty {
  display: flex;
  justify-content: center;
  margin-top: 110px;
}

.box .difficulty img {
  width: 80px;
  margin: 5px;
}
</style>

<script>
import { Jumper } from "vue-loading-spinner";

export default {
  name: "Difficulty",
  data: () => {
    return {
      currentlyPlaying: null
    };
  },
  components: {
    Jumper
  },
  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },
    play(file) {
      let audio = document.getElementById("difficultyAudio");
      audio.src = "sounds/" + file + "_" + this.$variables.gender + ".mp3";
      audio.play();
      audio.addEventListener("ended", () => {
        this.currentlyPlaying = null;
      });
      this.currentlyPlaying = file;
    },
    nextStep(level) {
      this.$variables.level = level;
      this.$router.push({
        name: "record",
        params: { lang: this.$route.params.lang }
      });
    }
  }
};
</script>

